import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactComponentElement} - AdminPropertyShowMeter component
 */
function AdminPropertyShowMeter(props) {
  if (!props) {
    return <Loading />;
  }

  const { meter } = props;
  const {
    id, identifier, active, primaryBillingPoint,
  } = meter;
  const { id: pbpId, identifier: primaryBillingPointIdentifier } = primaryBillingPoint;

  return (
    <tr>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/meters/${id}`}>
          {identifier}
        </Link>
        <br />
        <UUID uuid={id} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>
        <Link to={`/admin/primary-billing-points/${pbpId}`}>
          {primaryBillingPointIdentifier}
        </Link>
        <br />
        <UUID uuid={pbpId} />
      </td>
    </tr>
  );
}

AdminPropertyShowMeter.propTypes = {
  meter: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AdminPropertyShowMeter.defaultProps = {
  meter: null,
};

export default AdminPropertyShowMeter;
